 
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { Tabs, Tab } from '@mui/material';
import NewCtaTab from './NewCtaTab';
import ExistingCtaTab from './ExistingCtaTab';

function TabPanel(props) {
  // eslint-disable-next-line react/prop-types
  const { children, hidden, index } = props;

  return (
    <div
      id={`cta-${index}-tab`}
      role="tabpanel"
      style={{
        display: hidden ? 'none' : 'flex',
        flexDirection: 'column',
        gap: '24px',
        padding: '36px',
        overflow: 'auto',
        maxHeight: '510px',
      }}
    >
      {children}
    </div>
  );
}
const DialogContent = function DialogContent({
  tags = [],
  icons = [],
  existingCta = [],
  resetValues = () => {},
  inEdit = false,
}) {
  const intl = useIntl();
  const [tab, setTab] = useState(inEdit ? 1 : 0);

  const onChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  useEffect(() => {
    // resets form values when changing view to prevent incorrect data on submit
    resetValues();
  }, [tab]);

  return (
    <>
      <Tabs variant="fullWidth" value={tab} onChange={onChangeTab}>
        <Tab label={intl.messages.NEW} />
        <Tab
          label={intl.messages.ALREADY_EXISTING}
          disabled={existingCta.length === 0}
        />
      </Tabs>

      <TabPanel hidden={tab !== 0} index={0}>
        <NewCtaTab tab={tab} tags={tags} icons={icons} />
      </TabPanel>
      <TabPanel hidden={tab !== 1} index={1}>
        <ExistingCtaTab existingCta={existingCta} />
      </TabPanel>
    </>
  );
};

DialogContent.propTypes = {
  tags: PropTypes.array,
  icons: PropTypes.array,
  existingCta: PropTypes.array,
  inEdit: PropTypes.bool,
  resetValues: PropTypes.func,
};

export default DialogContent;
